export default __webpack_public_path__ + "static/media/santa-maria-6.1916d0e0.jpg";